export default __webpack_public_path__ + "static/x0-2ea708da148ae45e99539ed36d644678.mp3";